import { createFileRoute } from '@tanstack/react-router'
import { SidebarModule } from '@/config/permissions'
import { useModuleAccess } from '@/hooks/use-module-access'
import { FlowsList } from '@/features/flow/components/flow-list'

export const Route = createFileRoute('/_authenticated/flows/')({
  component: Flow,
})

function Flow() {
  useModuleAccess(SidebarModule.FLOWS)
  return <FlowsList />
}
